import { RoutePath } from '@/src/RoutePath';
import JamSpinner from '@/src/components/common/JamSpinner/JamSpinner';
import { REDIRECT_AFTER_PROFILE_CREATE } from '@/src/constants/common';
import { useUser } from '@/src/store/user.context';
import { User } from '@/src/types/User';
import SessionStorage from '@/src/utils/session-storage';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export const isProfileEmpty = (user?: User | null) => {
  return !user?.nickname;
};

/**
 * Component to redirect the user to the JAM profile if his/her profile is incomplete
 * or hide it and show a terms and conditions modal otherwise.
 */
export const JamProfileCheckGuard: React.FC = (props) => {
  const history = useHistory();
  const location = useLocation();
  const { loading, user } = useUser();
  const noProfileRedirectPaths: string[] = [RoutePath.OAUTH2, RoutePath.USER_PROFILE_CREATE];

  useEffect(() => {
    if (!user || loading) {
      return;
    }

    // Do not immediately redirect when the Oauth page loads - let Oauth do its own redirect first.
    // Also do not redirect to the profile create page when already on the profile create page.
    if (isProfileEmpty(user) && !noProfileRedirectPaths.includes(location.pathname)) {
      SessionStorage.set(REDIRECT_AFTER_PROFILE_CREATE, location);
      history.replace(RoutePath.USER_PROFILE_CREATE);
    }
  }, [history, user, loading, location.pathname]);

  if (loading) return <JamSpinner />;

  return <React.Fragment>{props.children}</React.Fragment>;
};
